import { BRIDGE_EVENTS } from "../shared/constants"
import type {
  BridgeMeta,
  MsgChildToParent,
  PayloadEmpty,
  PayloadOpenEventDetail,
  PayloadOpenPlace,
  PayloadOpenPromotionDetail,
  PayloadOpenSearch,
  PayloadShowDirections,
  PayloadStartNavigation,
  PayloadStep,
} from "../shared/types"

type ParentHandlers = {
  openSearch?: (payload: PayloadOpenSearch, meta: BridgeMeta) => void
  openPlace?: (payload: PayloadOpenPlace, meta: BridgeMeta) => void
  openServices?: (payload: PayloadEmpty, meta: BridgeMeta) => void
  openEvents?: (payload: PayloadEmpty, meta: BridgeMeta) => void
  openEventDetail?: (payload: PayloadOpenEventDetail, meta: BridgeMeta) => void
  openPromotions?: (payload: PayloadEmpty, meta: BridgeMeta) => void
  openPromotionDetail?: (
    payload: PayloadOpenPromotionDetail,
    meta: BridgeMeta
  ) => void
  openDirectory?: (payload: PayloadEmpty, meta: BridgeMeta) => void
  showDirections?: (payload: PayloadShowDirections, meta: BridgeMeta) => void
  startNavigation?: (payload: PayloadStartNavigation, meta: BridgeMeta) => void
  changeStepNavigation?: (payload: PayloadStep, meta: BridgeMeta) => void
}

export const createParentHandlers = ({
  openSearch = () => {},
  openPlace = () => {},
  openServices = () => {},
  openEvents = () => {},
  openEventDetail = () => {},
  openPromotions = () => {},
  openPromotionDetail = () => {},
  openDirectory = () => {},
  showDirections = () => {},
  startNavigation = () => {},
  changeStepNavigation = () => {},
}: ParentHandlers) => {
  return async (msg: MsgChildToParent, meta: BridgeMeta) => {
    switch (msg.type) {
      case BRIDGE_EVENTS.NAV_OPEN_SEARCH:
        return openSearch(msg.payload as PayloadOpenSearch, meta)
      case BRIDGE_EVENTS.NAV_OPEN_PLACE:
        return openPlace(msg.payload as PayloadOpenPlace, meta)
      case BRIDGE_EVENTS.NAV_OPEN_SERVICES:
        return openServices(msg.payload as PayloadEmpty, meta)
      case BRIDGE_EVENTS.NAV_OPEN_EVENTS:
        return openEvents(msg.payload as PayloadEmpty, meta)
      case BRIDGE_EVENTS.NAV_OPEN_EVENT_DETAIL:
        return openEventDetail(msg.payload as PayloadOpenPlace, meta)
      case BRIDGE_EVENTS.NAV_OPEN_PROMOTIONS:
        return openPromotions(msg.payload as PayloadEmpty, meta)
      case BRIDGE_EVENTS.NAV_OPEN_PROMOTION_DETAIL:
        return openPromotionDetail(msg.payload as PayloadOpenPlace, meta)
      case BRIDGE_EVENTS.NAV_OPEN_DIRECTORY:
        return openDirectory(msg.payload as PayloadEmpty, meta)
      case BRIDGE_EVENTS.NAV_SHOW_DIRECTIONS:
        return showDirections(msg.payload as PayloadShowDirections, meta)
      case BRIDGE_EVENTS.NAV_START_NAVIGATION:
        return startNavigation(msg.payload as PayloadStartNavigation, meta)
      case BRIDGE_EVENTS.NAV_NEXT_STEP_NAVIGATION:
      case BRIDGE_EVENTS.NAV_PREV_STEP_NAVIGATION:
        return changeStepNavigation(msg.payload as PayloadStep, meta)
      default:
        return
    }
  }
}
